import React, { useState } from "react";
import ornamentImages from "./ornament_images";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./OrnamentForm.css";

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          // Check if this cookie string begins with the name we want
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
              break;
          }
      }
  }
  return cookieValue;
}

function OrnamentForm({ onSubmit }) {
    const [message, setMessage] = useState("");
    const [selectedImage, setSelectedImage] = useState(ornamentImages[0].url); // Default selection
    const navigate = useNavigate(); // Initialize the navigate function

    /*const handleSubmit = (e) => {
        e.preventDefault();
        if (message.trim() === "") {
            alert("Message cannot be empty!");
            return;
        }

        onSubmit({
            message: message,
            image_url: selectedImage,
        });

        setMessage("");
        setSelectedImage(ornamentImages[0].url); // Reset selection
    };*/

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!process.env.REACT_APP_API_URL) {
          console.error("REACT_APP_API_URL is not set!");
          return;
        }
        if (message.trim() === "") {
          alert("Message cannot be empty!");
          return;
        }
        if (message.length > 1000) {
          alert("Message exceeds the maximum length of 1000 characters!");
          return;
        }
    
        try {
          
          const response = await fetch(`${process.env.REACT_APP_API_URL}/api/ornaments/`, {  // Adjust this URL to match your Django URL pattern
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              // Add CSRF token if needed
              'X-CSRFToken': getCookie('csrftoken'),
            },
            body: JSON.stringify({
              message: message,
              image_url: selectedImage,
              
            }),
            credentials: 'include', // If using sessions/CSRF
            
          });
    
          if (response.ok) {
            setMessage("");
            setSelectedImage(ornamentImages[0].url);
            alert('Ornament added successfully!');
          } else if (!response.ok) {
            const errorData = await response.json();
            console.error("Error response from server:", errorData);
            alert("Failed to add ornament: " + (errorData.detail || "Unknown error"));
            return;
          } else {
            alert('Failed to add ornament');
          }
          navigate('/tree');
        } catch (error) {
          console.error('Error:', error);
          alert('Error submitting ornament');
        }
      };

    return (
        <form onSubmit={handleSubmit} className="ornament-form">
            <div>
                <label htmlFor="message">Message:</label>
                <div></div>
                <textarea
                id="message"
                className="message-box"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows="4"
                cols="50"
                placeholder="Enter your message (max 1000 characters)"
                />
                <p>Note: please sign off with your name if you want it shown... I'm too tired to edit this site and just want to deploy...
                </p>
            </div>
            <div>
                <label>Select an Ornament:</label>
                <div className="ornament-options">
                    {ornamentImages.map((image) => (
                        <div
                            key={image.url}
                            className={`ornament-option ${
                                selectedImage === image.url ? "selected" : ""
                            }`}
                            onClick={() => setSelectedImage(image.url)}
                        >
                            <img src={`${process.env.REACT_APP_API_URL+image.url}`} alt={image.label} />
                        </div>
                    ))}
                </div>
            </div>
            <button type="submit" className="submit-button">
                Add Ornament
            </button>
        </form>
    );
}

export default OrnamentForm;

